module.exports = __webpack_public_path__ + "static/img/footLogo.874a5a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/footLogo.png
// module id = wnzk
// module chunks = 0